import { QueryKey, useQueryClient } from 'react-query';
import { useAccountingUpdateSocketEvent } from './useAccountingUpdateFromSocket';

type Params = {
  queries: QueryKey[];
};

export const useSocketAccountingEventInvalidator = ({ queries }: Params) => {
  const queryCache = useQueryClient();

  useAccountingUpdateSocketEvent({
    callback: () => {
      queries.forEach((query) => {
        queryCache.invalidateQueries(query);
      });
    },
  });
};
